import { AxiosRequestConfig } from "axios";
import PickRequestBuilder from "slotworks/integration/revolver/builders/requests/pick-request-builder";
import SpinRequestBuilder from "slotworks/integration/revolver/builders/requests/spin-request-builder";
import RevolverModel from "slotworks/integration/revolver/model/revolver-model";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import FreespinRequestPayload from "slotworks/model/gameplay/requests/freespin-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { log } from "util";
import campaignsModel from "slotworks/integration/revolver/model/campaigns-model";

class FreespinRequestBuilder implements RequestBuilder {

    public force: string;

    public filter(data: any): boolean {
        return data instanceof FreespinRequestPayload;
    }

    public build(gameplay: Gameplay, data: any) {

        const req: any = {
            cmd: "RESULTS",
            session: RevolverModel.session,
            additionalData: {}
        };

        // For some troubleshooting we need to add more metadata in the requests
        try {
            if (RevolverModel.getGameCode()) {
                req.additionalData.gameCode = RevolverModel.getGameCode();
            }
            if (RevolverModel.getOperator()) {
                req.additionalData.getOperator = RevolverModel.getOperator();
            }
            if (RevolverModel.getOperatorId()) {
                req.additionalData.getOperatorId = RevolverModel.getOperatorId();
            }
            if (RevolverModel.getBranding()) {
                req.additionalData.getBranding = RevolverModel.getBranding();
            }
            if (window && window.location) {
                if (window.location.hasOwnProperty("pathname")) {
                    req.additionalData.windowPath = window.location.pathname;
                }
            }
            if (RevolverModel.sendBetConfigInResult) {
                req.additionalData.betConfig = RevolverModel.betConfig;
            }
        } catch (e) {
            log(e);
        }


        if (this.force) {
            (req as any).action = {};
            (req as any).action.force = this.force;
            this.force = null;
            SpinRequestBuilder.force = null;
            PickRequestBuilder.force = null;
        }

        if (campaignsModel.isFreespinsActive()) {
            if(!req.action) req.action = {};
            req.action.availableCampaignDetails = {
                type: campaignsModel.freespins.type,
                awardId: campaignsModel.freespins.awardId
            };
        }

        const requestConfig = {
            method: "post",
            url: RevolverModel.getBaseURL(),
            withCredentials: true,
            data: JSON.stringify(req)
        } as AxiosRequestConfig;

        if (RevolverModel.jwt_token) {
            requestConfig.headers = {
                "X-RGS-SESSION-TOKEN": RevolverModel.jwt_token
            };
        }

        return requestConfig;
    }
}

export default new FreespinRequestBuilder();



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/builders/requests/freespin-request-builder.ts